import React, { useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import AddIcon from "@mui/icons-material/Add";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const ProductBrand = () => {
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [datas, setDatas] = useState(null);
  const [updateId, setUpdateId] = useState(-1);
  const [image, setImage] = useState("");
  const [brandData, setBrandData] = useState([]);
  const [open1, setOpen1] = React.useState(false);
  const storeId = localStorage.getItem("store_id");

  const [search, setSearch] = useState("");
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => {
    setOpen1(false);
    setDatas(null);
    setUpdateId(-1);
  };
  // const superuserId = localStorage.getItem("is_superuser");
  const superuserId = "true";

  const ProductDataList = () => {
    superuserId === "true"
      ? axios
          .post(
            `https://app1.crazzyhub.com/api/admin/multivendor-show-brand-list/?page=${page}&search=${search}`,
            { store_id: storeId },
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            setBrandData(response?.data?.brand_data);
            setCurrentPage(response.data.current_page);
            setTotalPage(response.data.total_pages);
          })
          .catch((error) => {
            console.log("", error);
          })
      : axios
          .post(
            `https://app1.crazzyhub.com/api/admin/multivendor-show-brand-list/?page=${page}&search=${search}`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            setBrandData(response?.data?.brand_data);
            setCurrentPage(response.data.current_page);
            setTotalPage(response.data.total_pages);
          })
          .catch((error) => {
            console.log("", error);
          });
  };

  useEffect(() => {
    ProductDataList();
  }, [page, search]);

  const formik = useFormik({
    initialValues: {
      product_brand_name: datas?.brand_name ?? "",
      meta_title: datas?.Meta_Title ?? "",
      meta_description: datas?.Meta_Description ?? "",
      meta_keyword: datas?.Meta_Keyword ?? "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const reqBody = new FormData();
      updateId == -1
        ? reqBody.append("image", image)
        : image && reqBody.append("image", image);
      reqBody.append("meta_title", values.meta_title);
      reqBody.append("meta_keyword", values.meta_keyword);
      reqBody.append("meta_description", values.meta_description);
      reqBody.append("product_brand_name", values.product_brand_name);
      updateId === -1 && reqBody.append("store_id", storeId);
      datas && reqBody.append("brand_id", datas.id);

      updateId === -1
        ? axios
            .post(
              `https://app1.crazzyhub.com/api/admin/multivendor-add-product-brand/`,
              reqBody,
              {
                headers: {
                  Token: localStorage.getItem("Token"),
                  "Content-Type": "multipart/formdata",
                },
              }
            )
            .then((response) => {
              // setStore(response?.data.store_list_data);
              toast.success(response.data.message);
              ProductDataList();
              handleClose1();
              formik.resetForm();
            })
            .catch((error) => {
              console.log("error page", error.response);
              console.log(error);
            })
        : axios
            .post(
              `https://app1.crazzyhub.com/api/admin/multivendor-update-show-brand-list/`,
              reqBody,
              {
                headers: {
                  Token: localStorage.getItem("Token"),
                  "Content-Type": "multipart/formdata",
                },
              }
            )
            .then((response) => {
              // setStore(response?.data.store_list_data);
              toast.success(response.data.message);
              ProductDataList();
              handleClose1();
              formik.resetForm();
            })
            .catch((error) => {
              console.log("error page", error.response);
              console.log(error);
            });
    },
  });

  const deleteBrand = (id) => {
    axios
      .delete(
        `https://app1.crazzyhub.com/api/admin/multivendor-update-show-brand-list/`,
        {
          data: {
            brand_id: id,
            // store_id: StoreID,
          },

          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        if (response.data.response_code == 200) {
          toast.success(response.data.message);
          ProductDataList();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log("error page", error.response);
        console.log(error);
      });
    // }
  };
  const handleChangePage = (event, value) => {
    setPage(value);
  };
  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Brand List
          </p>
        </div>
        <div className="p-2 pt-5"></div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 mx-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
              placeholder="search"
              onChange={(e) => setSearch(e.target.value)}
              style={{ border: "1px solid black" }}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              {superuserId === "true" ? (
                <Button variant="outlined" onClick={handleOpen1}>
                  <AddIcon className="!text-lg" /> Add Brand
                </Button>
              ) : null}
              <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 430 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {updateId == -1 ? "Add " : "Update "} Brand
                  </div>
                  <form onSubmit={formik.handleSubmit}>
                    <TextField
                      label="Brand Name"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="product_brand_name"
                      id="product_brand_name"
                      value={formik.values.product_brand_name}
                      onChange={formik.handleChange}
                    />
                    <br />
                    <TextField
                      type="file"
                      size="small"
                      className="!w-[100%] !mt-3"
                      name="image"
                      id="image"
                      onChange={(e) => setImage(e.target.files[0])}
                      value={formik.values.image}
                    />
                    <br />
                    <TextField
                      label="Meta keyword"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="meta_title"
                      id="meta_title"
                      onChange={formik.handleChange}
                      value={formik.values.meta_title}
                    />
                    <br />
                    <TextField
                      label="Meta Title"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="meta_description"
                      id="meta_description"
                      onChange={formik.handleChange}
                      value={formik.values.meta_description}
                    />
                    <br />
                    <TextField
                      label="Meta Keyword"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="meta_keyword"
                      id="meta_keyword"
                      onChange={formik.handleChange}
                      value={formik.values.meta_keyword}
                    />
                    <br />
                    <Button
                      onClick={handleClose1}
                      variant="contained"
                      color="warning"
                      className="!py-2 !mt-3"
                    >
                      CANCEL
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      type="submit"
                      className="!py-2 !px-8 !mt-3 bg-yellow-300 !float-right"
                    >
                      ADD
                    </Button>
                  </form>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer component={Paper} sx={{ maxHeight: "70vh" }}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  BUSINESS TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  BUSINESS SUB TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  BRAND NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  STATUS
                </TableCell>
                {superuserId === "true" ? (
                  <TableCell
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    ACTION
                  </TableCell>
                ) : null}
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {brandData &&
                brandData?.map((row, index) => (
                  <TableRow key={row?.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.business_type?.name
                        ? row?.business_type?.name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.business_type?.business_type?.name
                        ? row?.business_type?.business_type?.name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.brand_name ? row?.brand_name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img
                          src={row?.image}
                          alt="No"
                          className="h-8 mx-auto w-8"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.active ? (
                        <CheckCircleIcon className="text-green-500" />
                      ) : (
                        <CancelIcon className="text-red-500" />
                      )}
                    </TableCell>
                    {superuserId === "true" ? (
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <DeleteIcon
                          onClick={() => {
                            deleteBrand(row.id);
                          }}
                          className="!text-xl !text-red-600 !cursor-pointer"
                        />
                        <button onClick={handleOpen1}>
                          <EditIcon
                            className="!text-xl !cursor-pointer !text-green-600"
                            onClick={() => {
                              setDatas(row);
                              setUpdateId(row.id);
                              handleOpen1();
                            }}
                          />
                        </button>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {/* {totalPage !== 1 && ( */}
          <div className="flex justify-center p-2">
            <Pagination
              page={currentPage}
              size="small"
              count={totalPage}
              variant="outlined"
              color="primary"
              onChange={handleChangePage}
            />
          </div>
          {/* )} */}
        </TableContainer>
      </div>
    </div>
  );
};

export default ProductBrand;
